import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { BaseConfig } from './../../../../shared/service/base-config.service';
import { GenericHttpService } from './../../../../shared/service/generic-http.service';
import { ControleArquivoReceitaModelView, ValidacaoArquivo, DadosOnInitModelView, ControleArquivoReceitaFiltro, ControleArquivoReceita } from '../model/geracao-arquivo-ipm.model';


@Injectable()
export class GeracaoArquivoIpmService {
  private readonly urlBase: string;

  constructor(
    private baseConfig: BaseConfig,
    private readonly http: GenericHttpService<any>) {
  }

  public dadosOnInitFormulario (): Observable<DadosOnInitModelView> {

    let retorno: Observable<DadosOnInitModelView> = null;

    retorno = this.http.getAny(this.baseConfig.getBaseUrlApi().concat('/ipm/GeracaoArquivoIpm/DadosOnInitFormulario'), null);

    return retorno;
  }

  public consultarControleArquivoReceita(filtro: ControleArquivoReceitaFiltro): Observable<ControleArquivoReceitaModelView> {

    let retorno: Observable<ControleArquivoReceitaModelView> = null;

    retorno = this.http.post(this.baseConfig.getBaseUrlApi().concat('/ipm/GeracaoArquivoIpm/ConsultarGeracaoArquivoIpm'), filtro);

    return retorno;

  }

  public consultarControleArquivoReceitaTodos(): Observable<ControleArquivoReceitaModelView>{

    let retorno: Observable<ControleArquivoReceitaModelView> = null;

    retorno = this.http.getAny(this.baseConfig.getBaseUrlApi().concat('/ipm/GeracaoArquivoIpm/ConsultarGeracaoArquivoIpmTodos'),null);

    return retorno;

  }

  public gerarArquivoIpm(filtro : ControleArquivoReceitaFiltro ): Observable<any> {

    return this.http.DownloadTxt(this.baseConfig.getBaseUrlApi().concat('/ipm/GeracaoArquivoIpm/GerarArquivoIpm'), filtro);

  }

  public validarGeracaoArquivoIpm(filtro : ControleArquivoReceitaFiltro ): Observable<any> {

    return this.http.post(this.baseConfig.getBaseUrlApi().concat('/ipm/GeracaoArquivoIpm/ValidaGeracaoArquivoIpm'), filtro);

  }

  public validarArquivoIpm(filtro : ControleArquivoReceitaFiltro ): Observable<ValidacaoArquivo> {

    return this.http.post(this.baseConfig.getBaseUrlApi().concat('/ipm/GeracaoArquivoIpm/ValidacaoArquivoIpm'), filtro);

  }

  public gerarSequencialIpm(filtro : ControleArquivoReceitaFiltro ): Observable<ValidacaoArquivo> {

    return this.http.post(this.baseConfig.getBaseUrlApi().concat('/ipm/GeracaoArquivoIpm/GerarSequencialIpm'), filtro);

  }

  public alterarStatusArquivoIpm(item : ControleArquivoReceita ): Observable<ValidacaoArquivo> {

    return this.http.post(this.baseConfig.getBaseUrlApi().concat('/ipm/GeracaoArquivoIpm/AlterarStatusArquivoIpm'), item);

  }

  public permiteAlterarStatusArquivoIpm(item : ControleArquivoReceita ): Observable<boolean> {

    return this.http.post(this.baseConfig.getBaseUrlApi().concat('/ipm/GeracaoArquivoIpm/PermiteAlterarStatusArquivoIpm'), item);

  }
}


// WEBPACK FOOTER //
// ./src/app/ipm/geracao-arquivo-ipm/shared/service/geracao_arquivo-ipm.service.ts